export enum ModerationType {
  Pre = 'pre-moderation',
  Post = 'post-moderation',
  Hybrid = 'hybrid-moderation',
}
